import { render, staticRenderFns } from "./OnOffStatistics.vue?vue&type=template&id=77e4bf3b&scoped=true&"
import script from "./OnOffStatistics.vue?vue&type=script&lang=js&"
export * from "./OnOffStatistics.vue?vue&type=script&lang=js&"
import style0 from "./OnOffStatistics.vue?vue&type=style&index=0&id=77e4bf3b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e4bf3b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77e4bf3b')) {
      api.createRecord('77e4bf3b', component.options)
    } else {
      api.reload('77e4bf3b', component.options)
    }
    module.hot.accept("./OnOffStatistics.vue?vue&type=template&id=77e4bf3b&scoped=true&", function () {
      api.rerender('77e4bf3b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/statistics/onoff/OnOffStatistics.vue"
export default component.exports